var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaying = function SvgPlaying(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 5.667h-3.5c-.414 0-.75.447-.75 1v19c0 .552.336 1 .75 1h3.5c.414 0 .75-.448.75-1v-19c0-.553-.336-1-.75-1Zm3 7h3.5c.414 0 .75.447.75 1v12c0 .552-.336 1-.75 1h-3.5c-.414 0-.75-.448-.75-1v-12c0-.553.336-1 .75-1Zm-13 5.666h3.5c.414 0 .75.448.75 1v6.334c0 .552-.336 1-.75 1h-3.5c-.414 0-.75-.448-.75-1v-6.334c0-.552.336-1 .75-1Z",
    fill: "#000"
  })));
};
export default SvgPlaying;